import Component from 'vue-class-component'
import Vue from 'vue'
import ReactButton from './ReactButton.vue'
import statementStore from '@/store/statement/statement-store'
import authStore from '@/store/auth/auth-store';

@Component({
  name: 'jybeButtonNonauth',
  props: ['statement'],
  components: { 'react-button' : ReactButton }
})
export default class JybeButtonNonauth extends Vue {

  protected login (): void {
    authStore.dispatchLogin()
  }

}
